import React, { useEffect } from 'react';
import ChatWebsocketService from './ChatWebsocketService';
import useApi from '../api/useApi';

const ChatService = ({ onConnectionEstablished, socketLoggedOnCallback, socketLoggedOutCallback, timerTick, timerTimeout, messageReceived }) => {

    const api = useApi();

    const handleConnectionEstablished = () => {
        onConnectionEstablished();
    };

    const _chatWebsocketService = ChatWebsocketService({ onConnectionEstablished: handleConnectionEstablished });

    useEffect(() => {

        const userLoggedOnCallback = (user) => {
            socketLoggedOnCallback(user);
        };

        const userLoggedOutCallback = (user) => {
            socketLoggedOutCallback(user);
        };

        const timerTickCallback = (seconds) => {
            console.log("timerTickCallback called [seconds : "+seconds.toString()+"]"+new Date())
            timerTick(seconds);
        };

        const timerTimeoutCallback = (lotId) => {
            console.log("timerTimeoutCallback called [lotId : " + lotId.toString() + "]" + new Date())
            timerTimeout(lotId);
        };

        const messageReceivedCallback = (message) => {
            messageReceived(message);
        };

        _chatWebsocketService.registerUserLoggedOn(userLoggedOnCallback);
        _chatWebsocketService.registerUserLoggedOut(userLoggedOutCallback);

        _chatWebsocketService.registerTimerTick(timerTickCallback);
        _chatWebsocketService.registerTimerTimeout(timerTimeoutCallback);
        _chatWebsocketService.registerMessageReceived(messageReceivedCallback);

        return () => {
            // Cleanup logic, if needed
            console.log("CLEAN UP IN CHAT SERVICE")
        };
    }, [socketLoggedOnCallback, socketLoggedOutCallback, timerTick, timerTimeout, messageReceived]);

    const sendMessage = (message) => {
        _chatWebsocketService.sendMessage(message);
    };

    const getOnlineUsers = async (fetchInitialUsersCallback) => {
        try {
            const onlineUsers = await api.getCurrentConnectedTraders();
            fetchInitialUsersCallback(onlineUsers);
        } catch (error) {
            console.error('Error fetching logged-on users:', error);
        }
    };

    return {
        sendMessage,
        getOnlineUsers,
    };
};

export default ChatService;
